var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    {
      staticClass: "elevation-0 base-expansion",
      attrs: { multiple: "" },
      model: {
        value: _vm.panelValue,
        callback: function($$v) {
          _vm.panelValue = $$v
        },
        expression: "panelValue"
      }
    },
    [
      _c(
        "v-expansion-panel",
        [
          _c(
            "v-expansion-panel-header",
            [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
            2
          ),
          _c("v-expansion-panel-content", [_vm._t("default")], 2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }